import { z } from "zod";

/** Mirrors packages/shared/src/progression/xp.ts's LevelProgress shape as a wire DTO. */
export const levelProgressSchema = z.object({
  level: z.number().int(),
  totalXp: z.number().int(),
  currentLevelThreshold: z.number().int(),
  nextLevelThreshold: z.number().int(),
  xpIntoLevel: z.number().int(),
  xpForNextLevel: z.number().int(),
  xpRemainingToNextLevel: z.number().int(),
  progressRatio: z.number(),
});

export type LevelProgressDTO = z.infer<typeof levelProgressSchema>;

export const streakSummarySchema = z.object({
  currentStreak: z.number().int(),
  longestStreak: z.number().int(),
  /** JAIHO game-day key (YYYY-MM-DD in GAME_DAY_TIMEZONE), or null if never claimed. */
  lastClaimedGameDay: z.string().nullable(),
});

export type StreakSummaryDTO = z.infer<typeof streakSummarySchema>;
